import Vue from "vue";

Vue.component("publication-media-basic-info-editor", {
    props: ["useModal", "contextId"],
    data() {
        return {
            loading: false,
            showModal: false,
            counter: 0,
            currentId: this.contextId,
            id: 0,
            referenceNumber: '',
            displayOrder: 0,
            headings: [
                { value: null, display: window.labels.notApplicable, fontSize: null },
                { value: 'h1', display: 'Heading 1', fontSize: '2em' },
                { value: 'h2', display: 'Heading 2', fontSize: '1.75em' },
                { value: 'h3', display: 'Heading 3', fontSize: '1.5em' },
                { value: 'h4', display: 'Heading 4', fontSize: '1.25em' },
                { value: 'h5', display: 'Heading 5', fontSize: '1.125em' },
                { value: 'h6', display: 'Heading 6', fontSize: '1em' }
            ],
            placements: [
                { value: null, display: window.labels.notApplicable },
                { value: 1, display: 'First column' },
                { value: 2, display: 'Second column' }
            ],
            indentations: [
                { value: null, display: window.labels.notApplicable },
                { value: '20px', display: '1st level' },
                { value: '40px', display: '2nd level' },
                { value: '60px', display: '3rd level' },
                { value: '80px', display: '4th level' },
                { value: '100px', display: '5th level' },
                { value: '120px', display: '6th level' },
                { value: '140px', display: '7th level' },
                { value: '160px', display: '8th level' },
                { value: '180px', display: '9th level' },
                { value: '200px', display: '10th level' }
            ],
            heading: null,
            columnNo: null,
            indentation: null,
            visible: false,
            textEn: null,
            textEs: null,
            textFr: null,
            currentLanguage: window.currentLanguage,
            language: window.currentLanguage,
            languages: {
                'English': 'EN',
                'French': 'FR',
                'Spanish': 'ES'
            }
        };
    },
    methods: {
        initialize(publicationMediaId) {
            const self = this;

            self.id = publicationMediaId;
            self.loading = true;

            self.$services.publicationMediasService.getById({
                id: publicationMediaId,
                language: window.currentLanguage
            }).then((data) => {
                console.log(data);
                self.id = data.id;
                self.referenceNumber = data.referenceNumber;
                self.columnNo = data.columnNo;
                self.indentation = data.indentation;
                self.visible = (data.visible == null || (data.visible != null && data.visible)) ? true : false;

                self.heading = data.heading;
                
                self.textEn = data.textEn;
                self.textEs = data.textEs;
                self.textFr = data.textFr;
                self.displayOrder = data.displayOrder;

                self.loading = false;

                if (self.useModal) {
                    self.showModal = true;
                }
            });
        },
        discard() {
            const self = this;

            self.id = 0;
            self.referenceNumber = null;
            self.columnNo = null;
            self.indentation = null;
            self.visible = null;
            self.heading = null;
            self.textEn = null;
            self.textEs = null;
            self.textFr = null;
            self.displayOrder = 0;

            self.showModal = false;
        },
        save() {
            const self = this;
            const param = {
                id: self.id,
                referenceNumber: self.referenceNumber,
                columnNo: self.columnNo,
                indentation: self.indentation,
                visible: self.visible,
                heading: self.heading,
                textEn: self.textEn,
                textEs: self.textEs,
                textFr: self.textFr,
                displayOrder: self.displayOrder
            };

            console.log(param);

            self.$services.publicationMediasService.save(param).then((data) => {
                if (data) {
                    self.counter += 1;
                    self.currentId = self.id + '|1|' + self.counter;

                    self.$emit('update:contextId', self.currentId);

                    self.$buefy.snackbar.open(window.messages.publicationMediaSuccessfullyStored);
                    self.id = 0;
                    self.referenceNumber = null;
                    self.columnNo = null;
                    self.indentation = null;
                    self.visible = null;
                    self.heading = null;
                    self.textEn = null;
                    self.textEs = null;
                    self.textFr = null;
                    self.displayOrder = 0;

                    self.showModal = false;
                }
                else {
                    self.$buefy.snackbar.open(window.messages.publicationMediaUnuccessfullyStored);
                }

                if (self.useModal) {
                    self.showModal = false;
                }
            });
        }
    },
    computed: {
        dataManagementBasicInformationLabel: function () {
            return window.labels.dataManagementBasicInformation;
        },
        dataManagementBasicInfoReferenceNumberLabel: function () {
            return window.labels.dataManagementBasicInfoReferenceNumber;
        },
        dataManagementBasicInfoDisplayOrderLabel: function () {
            return window.labels.dataManagementBasicInfoDisplayOrder;
        },        
        dataManagementSaveLabel: function () {
            return window.labels.dataManagementSave;
        },
        dataManagementCancelLabel: function () {
            return window.labels.dataManagementCancel;
        },
        publicationMediaEditLabel: function () {
            return window.labels.publicationMediaEdit;
        },
        publicationMediaVisibleLabel: function () {
            return window.labels.publicationMediaVisible;
        },
        publicationMediaTextLabel: function () {
            return window.labels.publicationMediaText;
        },
        publicationMediaIndentationLabel: function () {
            return window.labels.publicationMediaIndentation;
        },
        publicationMediaHeadingLabel: function () {
            return window.labels.publicationMediaHeading;
        },
        specifyLevelLabel: function () {
            return window.labels.specifyLevel;
        },
        specifyHeadingLabel: function () {
            return window.labels.specifyHeading;
        }
    },
    template: `
        <div>
            <b-modal full-screen id="publicationMediaFormModal" ref="publicationMediaFormModal" :canCancel="false" v-model="showModal">
                <div class="modal-card" style="overflow-y: auto;">
                    <header class="modal-card-head">
                        <p class="modal-card-title">{{publicationMediaEditLabel}}</p>
                        <button type="button" class="delete" @click="discard"/>
                    </header>
                    <section class="modal-card-body">
                        <div class="card">                        
                            <div class="card-content">                            
                                <template v-if="loading"><loading></loading></template>
                                <template v-else>
                                    <div class="content">
                                        <div class="columns">
                                            <div class="column">
                                                <b-field :label="dataManagementBasicInfoReferenceNumberLabel">
                                                    <b-input v-model="referenceNumber"></b-input>
                                                </b-field>
                                            </div>
                                            <div class="column">
                                                <b-field :label="dataManagementBasicInfoDisplayOrderLabel">
                                                    <b-numberinput v-model="displayOrder"></b-numberinput>
                                                </b-field>
                                            </div>
                                        </div>
                                        <div class="columns">
                                            <div class="column">
                                                <toggle-switch :values="languages" :selected.sync="language" default="currentLanguage"></toggle-switch>
                                            </div>
                                            <div class="column">
                                                <b-field :label="publicationMediaVisibleLabel">
                                                    <b-checkbox v-model="visible"></b-checkbox>
                                                </b-field>
                                            </div>
                                        </div>
                                        <div class="columns">
                                            <div class="column">
                                                <b-field :label="publicationMediaTextLabel">
									                <b-input v-model="textEn" v-if="language == 'English'"></b-input>
									                <b-input v-model="textFr" v-if="language == 'French'"></b-input>
									                <b-input v-model="textEs" v-if="language == 'Spanish'"></b-input>
								                </b-field>
                                            </div>                                            
                                        </div>
                                        <div class="columns">
                                            <div class="column">
                                                <b-field :label="publicationMediaIndentationLabel">
                                                    <b-select v-model="indentation" :placeholder="specifyLevelLabel">
                                                        <option
                                                            v-for="indentation in indentations"
                                                            :value="indentation.value"
                                                            :key="indentation.value">
                                                            {{indentation.display}}
                                                        </option>
                                                    </b-select>
                                                </b-field>
                                            </div>
                                            <div class="column">
                                                <b-field :label="publicationMediaHeadingLabel">
                                                    <b-select v-model="heading" :placeholder="specifyHeadingLabel">
                                                        <option
                                                            v-for="heading in headings"
                                                            :value="heading.value"
                                                            :key="heading.value"
                                                            :style="'font-size:' + heading.fontSize">
                                                            {{heading.display}}
                                                        </option>
                                                    </b-select>
                                                </b-field>
                                            </div>
                                        </div>                                        
                                    </div>
                                </template>
                            </div>
                        </div>
                    </section>
                    <footer class="modal-card-foot buttons">
					    <button type="button" class="button is-primary" @click="save">{{dataManagementSaveLabel}}</button>
					    <button type="button" class="button is-danger" @click="discard">{{dataManagementCancelLabel}}</button>
                    </footer>
                </div>
            </b-modal>            
		</div>
	`
});